import { render, staticRenderFns } from "./SettlementModal.vue?vue&type=template&id=b59f53fc"
import script from "./SettlementModal.vue?vue&type=script&lang=js"
export * from "./SettlementModal.vue?vue&type=script&lang=js"
import style0 from "./SettlementModal.vue?vue&type=style&index=0&id=b59f53fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports